import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getProductoById } from '../services/productos'; // Need to ensure this exists or use getProductos and find
import ProductDetail from '../components/ProductDetail';
import SearchBar from '../components/SearchBar';
import { Producto } from '../types';
import '../styles/ProductPage.css'; // Reusing existing styles or create specific ones

const ProductDetailPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const [product, setProduct] = useState<Producto | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        const fetchProduct = async () => {
            // Check if product is passed via state
            const stateProduct = location.state?.product as Producto;
            if (stateProduct) {
                setProduct(stateProduct);
                setLoading(false);
                return;
            }

            if (!id) return;
            try {
                const data = await getProductoById(parseInt(id));
                setProduct(data);
            } catch (err) {
                console.error("Error fetching product", err);
                setError("No se pudo cargar el producto.");
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [id, location.state]);

    const handleSearch = (query: string) => {
        navigate(`/productos?q=${encodeURIComponent(query)}`);
    };

    const handleClose = () => {
        navigate('/productos');
    };

    const handleEdit = (prod: Producto) => {
        navigate(`/productos/editar/${prod.id}`, { state: { product: prod } });
    };

    if (loading) return <div>Cargando...</div>;
    if (error || !product) return <div>{error || "Producto no encontrado"}</div>;

    return (
        <div className="page">
            <SearchBar
                placeholder="Buscar productos..."
                onSearch={handleSearch}
            />
            {/* Wrapper to match partial modal styling or just container */}
            <div style={{ padding: '20px' }}>
                <ProductDetail
                    product={product}
                    onClose={handleClose}
                    handleEdit={handleEdit}
                />
            </div>
        </div>
    );
};

export default ProductDetailPage;
